import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";

const AddClientHome = () => {
  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3">
                <h6 className="m-0 fw-bold themeBlue">Add New Clients</h6>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Form>
                <div
                  className="py-3"
                  style={{ borderTop: "1px solid #41a2a84d" }}
                >
                  <Row>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g Smith"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        DOB
                      </label>
                      <input
                        type="date"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Gender
                      </label>
                      <Form.Select
                        className={`${styles.formControl} form-control`}
                        aria-label="Default select example"
                      >
                        <option>Select Gender</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Grade
                      </label>
                      <Form.Select
                        className={`${styles.formControl} form-control`}
                        aria-label="Default select example"
                      >
                        <option>Please select Grade</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        City/Town
                      </label>
                      <Form.Select
                        className={`${styles.formControl} form-control`}
                        aria-label="Default select example"
                      >
                        <option>Please select Grade</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Services Status
                      </label>
                      <Form.Select
                        className={`${styles.formControl} form-control`}
                        aria-label="Default select example"
                      >
                        <option>Not Seen Yet</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Home Education Authority
                      </label>
                      <input
                        type="text"
                        placeholder="Please Enter"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Date of Intake
                      </label>
                      <input
                        type="date"
                        // placeholder="e.g John Smith"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                  </Row>
                </div>
                <div
                  className="py-3"
                  style={{ borderTop: "1px solid #41a2a84d" }}
                >
                  <Row>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Parent Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g Smith"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Parent Number
                      </label>
                      <input
                        type="tel"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Parent Email
                      </label>
                      <input
                        type="email"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                  </Row>
                </div>
                <div
                  className="py-3"
                  style={{ borderTop: "1px solid #41a2a84d" }}
                >
                  <Row>
                    <Col md="12" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Notes
                      </label>
                      <textarea
                        name=""
                        rows={5}
                        id=""
                        className={`${styles.formControl} form-control h-auto`}
                      ></textarea>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Upload Contract
                      </label>
                      <div className="iconWithText position-relative">
                        <input
                          type="text"
                          placeholder="Please select"
                          className={`${styles.formControl} form-control`}
                        />
                        <span
                          className="icn position-absolute"
                          style={{ right: 5 }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="13"
                            viewBox="0 0 20 13"
                            fill="none"
                          >
                            <path
                              d="M15 12.9486V10.1065H12V8.21176H15V5.36966H17V8.21176H20V10.1065H17V12.9486H15ZM9 10.1065H5C3.61667 10.1065 2.4375 9.64466 1.4625 8.72097C0.4875 7.79729 0 6.68018 0 5.36966C0 4.05913 0.4875 2.94202 1.4625 2.01834C2.4375 1.09465 3.61667 0.632812 5 0.632812H9V2.52755H5C4.16667 2.52755 3.45833 2.80387 2.875 3.3565C2.29167 3.90913 2 4.58018 2 5.36966C2 6.15913 2.29167 6.83018 2.875 7.38281C3.45833 7.93544 4.16667 8.21176 5 8.21176H9V10.1065ZM6 6.31702V4.42229H14V6.31702H6ZM20 5.36966H18C18 4.58018 17.7083 3.90913 17.125 3.3565C16.5417 2.80387 15.8333 2.52755 15 2.52755H11V0.632812H15C16.3833 0.632812 17.5625 1.09465 18.5375 2.01834C19.5125 2.94202 20 4.05913 20 5.36966Z"
                              fill="#1C1B1F"
                            />
                          </svg>
                        </span>
                      </div>
                      <ul
                        className={`${styles.list} list-unstyled ps-2 mb-0 pt-2`}
                        style={{ maxWidth: 300 }}
                      >
                        <li className="d-flex align-items-center justify-content-between gap-10">
                          <div className="left d-flex align-items-center">
                            <span className="icn me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="20"
                                viewBox="0 0 16 20"
                                fill="none"
                              >
                                <path
                                  d="M4 10V8H12V10H4ZM4 6V4H12V6H4ZM2 12H9.5C9.98333 12 10.4333 12.1042 10.85 12.3125C11.2667 12.5208 11.6167 12.8167 11.9 13.2L14 15.95V2H2V12ZM2 18H13.05L10.325 14.425C10.225 14.2917 10.1042 14.1875 9.9625 14.1125C9.82083 14.0375 9.66667 14 9.5 14H2V18ZM14 20H2C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20Z"
                                  fill="#071E3E"
                                />
                              </svg>
                            </span>
                            <p className="m-0 text-muted">Consent forms</p>
                          </div>
                          <Button
                            className="border-0 p-0"
                            variant={"transparent"}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M4.09873 9.17109L5.01361 10.0686L6.80871 8.23887L8.63847 10.034L9.53602 9.11909L7.70626 7.32399L9.50136 5.49423L8.58648 4.59668L6.79138 6.42644L4.96162 4.63135L4.06407 5.54623L5.89383 7.34132L4.09873 9.17109ZM2.3123 11.9071C1.67951 11.2863 1.20264 10.5828 0.881693 9.79661C0.560747 9.01045 0.396373 8.20957 0.388574 7.39397C0.380774 6.57838 0.5298 5.7745 0.835652 4.98234C1.1415 4.19019 1.60483 3.47771 2.22564 2.84492C2.84644 2.21212 3.54993 1.73525 4.33609 1.41431C5.12226 1.09336 5.92314 0.928987 6.73873 0.921187C7.55432 0.913387 8.3582 1.06241 9.15036 1.36827C9.94252 1.67412 10.655 2.13745 11.2878 2.75825C11.9206 3.37905 12.3975 4.08254 12.7184 4.8687C13.0393 5.65487 13.2037 6.45575 13.2115 7.27134C13.2193 8.08694 13.0703 8.89081 12.7644 9.68297C12.4586 10.4751 11.9953 11.1876 11.3745 11.8204C10.7536 12.4532 10.0502 12.9301 9.264 13.251C8.47783 13.572 7.67696 13.7363 6.86136 13.7441C6.04577 13.7519 5.24189 13.6029 4.44973 13.2971C3.65757 12.9912 2.9451 12.5279 2.3123 11.9071ZM3.20985 10.9922C4.23147 11.9944 5.44459 12.4889 6.84923 12.4754C8.25386 12.462 9.45731 11.9445 10.4596 10.9229C11.4618 9.90123 11.9562 8.68811 11.9428 7.28348C11.9294 5.87884 11.4119 4.67539 10.3902 3.67313C9.36862 2.67087 8.1555 2.17645 6.75086 2.18989C5.34623 2.20332 4.14278 2.72085 3.14052 3.74246C2.13826 4.76408 1.64384 5.97721 1.65727 7.38184C1.67071 8.78647 2.18823 9.98992 3.20985 10.9922Z"
                                fill="#FF000F"
                              />
                            </svg>
                          </Button>
                        </li>
                      </ul>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Attach Documents
                      </label>
                      <div className="iconWithText position-relative">
                        <input
                          type="text"
                          placeholder="Please select"
                          className={`${styles.formControl} form-control`}
                        />
                        <span
                          className="icn position-absolute"
                          style={{ right: 5 }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="13"
                            viewBox="0 0 20 13"
                            fill="none"
                          >
                            <path
                              d="M15 12.9486V10.1065H12V8.21176H15V5.36966H17V8.21176H20V10.1065H17V12.9486H15ZM9 10.1065H5C3.61667 10.1065 2.4375 9.64466 1.4625 8.72097C0.4875 7.79729 0 6.68018 0 5.36966C0 4.05913 0.4875 2.94202 1.4625 2.01834C2.4375 1.09465 3.61667 0.632812 5 0.632812H9V2.52755H5C4.16667 2.52755 3.45833 2.80387 2.875 3.3565C2.29167 3.90913 2 4.58018 2 5.36966C2 6.15913 2.29167 6.83018 2.875 7.38281C3.45833 7.93544 4.16667 8.21176 5 8.21176H9V10.1065ZM6 6.31702V4.42229H14V6.31702H6ZM20 5.36966H18C18 4.58018 17.7083 3.90913 17.125 3.3565C16.5417 2.80387 15.8333 2.52755 15 2.52755H11V0.632812H15C16.3833 0.632812 17.5625 1.09465 18.5375 2.01834C19.5125 2.94202 20 4.05913 20 5.36966Z"
                              fill="#1C1B1F"
                            />
                          </svg>
                        </span>
                      </div>
                      <ul
                        className={`${styles.list} list-unstyled ps-2 mb-0 pt-2`}
                        style={{ maxWidth: 300 }}
                      >
                        <li className="d-flex align-items-center justify-content-between gap-10">
                          <div className="left d-flex align-items-center">
                            <span className="icn me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="20"
                                viewBox="0 0 16 20"
                                fill="none"
                              >
                                <path
                                  d="M4 10V8H12V10H4ZM4 6V4H12V6H4ZM2 12H9.5C9.98333 12 10.4333 12.1042 10.85 12.3125C11.2667 12.5208 11.6167 12.8167 11.9 13.2L14 15.95V2H2V12ZM2 18H13.05L10.325 14.425C10.225 14.2917 10.1042 14.1875 9.9625 14.1125C9.82083 14.0375 9.66667 14 9.5 14H2V18ZM14 20H2C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20Z"
                                  fill="#071E3E"
                                />
                              </svg>
                            </span>
                            <p className="m-0 text-muted">Discharge reports</p>
                          </div>
                          <Button
                            className="border-0 p-0"
                            variant={"transparent"}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                            >
                              <path
                                d="M4.09873 9.17109L5.01361 10.0686L6.80871 8.23887L8.63847 10.034L9.53602 9.11909L7.70626 7.32399L9.50136 5.49423L8.58648 4.59668L6.79138 6.42644L4.96162 4.63135L4.06407 5.54623L5.89383 7.34132L4.09873 9.17109ZM2.3123 11.9071C1.67951 11.2863 1.20264 10.5828 0.881693 9.79661C0.560747 9.01045 0.396373 8.20957 0.388574 7.39397C0.380774 6.57838 0.5298 5.7745 0.835652 4.98234C1.1415 4.19019 1.60483 3.47771 2.22564 2.84492C2.84644 2.21212 3.54993 1.73525 4.33609 1.41431C5.12226 1.09336 5.92314 0.928987 6.73873 0.921187C7.55432 0.913387 8.3582 1.06241 9.15036 1.36827C9.94252 1.67412 10.655 2.13745 11.2878 2.75825C11.9206 3.37905 12.3975 4.08254 12.7184 4.8687C13.0393 5.65487 13.2037 6.45575 13.2115 7.27134C13.2193 8.08694 13.0703 8.89081 12.7644 9.68297C12.4586 10.4751 11.9953 11.1876 11.3745 11.8204C10.7536 12.4532 10.0502 12.9301 9.264 13.251C8.47783 13.572 7.67696 13.7363 6.86136 13.7441C6.04577 13.7519 5.24189 13.6029 4.44973 13.2971C3.65757 12.9912 2.9451 12.5279 2.3123 11.9071ZM3.20985 10.9922C4.23147 11.9944 5.44459 12.4889 6.84923 12.4754C8.25386 12.462 9.45731 11.9445 10.4596 10.9229C11.4618 9.90123 11.9562 8.68811 11.9428 7.28348C11.9294 5.87884 11.4119 4.67539 10.3902 3.67313C9.36862 2.67087 8.1555 2.17645 6.75086 2.18989C5.34623 2.20332 4.14278 2.72085 3.14052 3.74246C2.13826 4.76408 1.64384 5.97721 1.65727 7.38184C1.67071 8.78647 2.18823 9.98992 3.20985 10.9922Z"
                                fill="#FF000F"
                              />
                            </svg>
                          </Button>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
                <Row className="mt-5 ">
                  <Col className="my-2" lg="12">
                    <div
                      className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                      style={{ borderTop: "1px solid #41a2a84d" }}
                    >
                      <Button className="d-flex align-items-center justify-content-center commonBtn">
                        Save
                      </Button>
                      <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent">
                        Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddClientHome;
